import { IMG } from "../lib/brand";
import { motion } from "framer-motion";
import { useContent } from "../context/ContentContext";

export default function Hero({ onJoinClick }) {
    const { content } = useContent();
    const h = content.hero;
    const bg = h.background_image || IMG.hero;

    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen w-full overflow-hidden flex items-end"
        >
            <div className="absolute inset-0">
                <img src={bg} alt="Riders" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black" />
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-transparent" />
            </div>

            <div className="absolute left-6 md:left-12 top-1/2 -translate-y-1/2 hidden md:flex flex-col items-center gap-6 z-10">
                <div className="w-px h-24 bg-meraki-gold/40" />
                <div className="text-[10px] uppercase tracking-[0.3em] text-meraki-gold" style={{ writingMode: "vertical-rl" }}>
                    {h.side_rail}
                </div>
                <div className="w-px h-24 bg-meraki-gold/40" />
            </div>

            <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 pb-20 md:pb-32">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: "easeOut" }}
                    className="max-w-4xl"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-12 h-px bg-meraki-gold" />
                        <span className="text-[10px] uppercase tracking-[0.4em] text-meraki-gold">{h.eyebrow}</span>
                    </div>

                    <h1 data-testid="hero-title" className="font-display text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] leading-[0.85] text-meraki-text uppercase">
                        {h.title_line1}
                        <span className="block text-meraki-gold">{h.title_line2}</span>
                        <span className="block">{h.title_line3}</span>
                    </h1>

                    <p className="mt-8 max-w-2xl text-base md:text-lg text-meraki-text/85 leading-relaxed whitespace-pre-line">
                        {h.paragraph}
                    </p>

                    <div className="mt-10 flex flex-wrap gap-4 items-center">
                        <button
                            data-testid="hero-join-btn"
                            onClick={onJoinClick}
                            className="px-8 py-4 bg-meraki-gold text-black text-xs uppercase tracking-[0.25em] font-bold hover:bg-meraki-gold-hover transition-all hover:translate-y-[-2px]"
                        >
                            {h.cta_primary}
                        </button>
                        <a
                            data-testid="hero-explore-btn"
                            href="#about"
                            className="px-8 py-4 border border-meraki-gold/60 text-meraki-gold text-xs uppercase tracking-[0.25em] font-semibold hover:bg-meraki-gold/10 transition-colors"
                        >
                            {h.cta_secondary}
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
